import { App, DirectiveBinding } from "vue";
import DOMPurify from "dompurify";

export default {
    install: (app: App) => {
        app.directive("sanitize", {
            // Hook monté pour nettoyage initial
            beforeMount(el: HTMLInputElement | HTMLTextAreaElement, binding: DirectiveBinding) {
                el.value = DOMPurify.sanitize(el.value || "");

                el.addEventListener("input", (event: Event) => {
                    const inputElement = event.target as HTMLInputElement | HTMLTextAreaElement;
                    const sanitizedValue = DOMPurify.sanitize(inputElement.value);

                    if (inputElement.value !== sanitizedValue) {
                        inputElement.value = sanitizedValue;
                        inputElement.dispatchEvent(new Event("input")); // Met à jour v-model
                    }
                });
            },
            updated(el: HTMLInputElement | HTMLTextAreaElement, binding: DirectiveBinding) {
                const sanitizedValue = DOMPurify.sanitize(binding.value);
                if (el.value !== sanitizedValue) {
                    el.value = sanitizedValue;
                    el.dispatchEvent(new Event("input"));
                }
            },
        });
    },
};
